<template>
	<div>
		<div class="spinner-border" v-if="loader" style="margin:auto;display:block;margin-top:60px"/>
		<div class="col-sm-12 row" v-else>
			<div class="col-sm-11">
				<form v-on:submit.prevent>
					<div
						class="row"
						style="border-bottom: 2px solid #115E67;margin-bottom: 10px;font-size: 20px;padding: 5px 0px 0px 5px;"
						v-if="clientData && clientData.client_name"
					>
						<label style="margin: 0px;">Client</label>
					</div>
					<div style="border:1px #d4d4d4 solid; padding:20px">
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">Client Name</label>
							<label
								class="col-sm-10 pr-5"
								v-if="clientData.client_name"
								style="padding-top: calc(.375rem + 1px);"
							>{{clientData.client_name}}</label>
							<label
								class="col-sm-10 pr-5"
								v-else
								style="padding-top: calc(.375rem + 1px);color:red"
							>Not Provided</label>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">GO Director of Customer Marketing & Sales</label>
							<label
								v-if="clientData.go_retail"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>{{parsedContacts(clientData.go_retail)}}</label>
							<label
								v-else
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">GO Account Manager</label>
							<label
								v-if="clientData.client_main_contact"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>{{parsedContacts(clientData.client_main_contact)}}</label>
							<label
								v-else
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">GO Sponsored Ads</label>
							<label
								v-if="clientData.go_marketing"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>{{parsedContacts(clientData.go_marketing)}}</label>
							<label
								v-else
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">GO Operations Contact</label>
							<label
								v-if="clientData.go_ops"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>{{parsedContacts(clientData.go_ops) }}</label>
							<label
								v-else
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">GO Brand Manager Contact</label>
							<label
								v-if="clientData.go_brand"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>{{parsedContacts(clientData.go_brand) }}</label>
							<label
								v-else
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">GO DSP Contact</label>
							<label
								v-if="clientData.go_dsp"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>{{parsedContacts(clientData.go_dsp) }}</label>
							<label
								v-else
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">GO Digital Media Contact</label>
							<label
								v-if="clientData.go_media"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>{{parsedContacts(clientData.go_media) }}</label>
							<label
								v-else
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">GO Digital Content Contact</label>
							<label
								v-if="clientData.go_content"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>{{parsedContacts(clientData.go_content) }}</label>
							<label
								v-else
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">GO BA Contact</label>
							<label
								v-if="clientData.go_ba"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>{{parsedContacts(clientData.go_ba) }}</label>
							<label
								v-else
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">GO Other Contact</label>
							<label
								v-if="clientData.go_other"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>{{parsedContacts(clientData.go_other) }}</label>
							<label
								v-else
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">Partner UUID</label>
							<label
								v-if="clientData.partner_uuid"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>{{clientData.partner_uuid }}</label>
							<label
								v-else
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">Dominate/<wbr/>Drive/<wbr/>Deliver</label>
							<label
								v-if="clientData.go_initiative"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
							>{{clientData.go_initiative }}</label>
							<label
								v-else
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
						<div class="form-group row">
							<label class="col-sm-2 col-form-label text-right label-wrapper-style">SharePoint Files</label>
							<a
								v-if="clientData.sharepoint_link"
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style"
								href="javascript:void(0)"
								@click="openLinkInNewTab(clientData.sharepoint_link)"
							>{{clientData.sharepoint_link }}</a>
							<label
								v-else
								class="col-sm-10 pr-5 align-self-center label-value-wrapper-style label-not-provided-wrapper"
							>Not Provided</label>
						</div>
					</div>
						<div v-for="(profile,index) in profileData" :key="index">
							<AdAccountView :profile="profile" v-if="profile.type=='Ad Accounts'"/>
							<SellerView :profile="profile" :clientData='clientData' v-if="profile.type=='Seller'"/>
							<VendorView :profile="profile" :clientData='clientData' v-if="profile.type=='Vendor'"/>
							<InstacartView :profile="profile" v-if="profile.type=='Instacart Accounts'"/>
							<DSPView :profile="profile" v-if="profile.type =='DSP Accounts'"/>
							<AMCView :profile="profile" v-if="profile.type =='AMC Accounts'"/>
						</div>
		
				</form>
			</div>
		</div>
		<ListNamesPopUp
			ref="listPopUp"
			:namesArray="details"
			:type="type"
			:clientName="name"
			:showSpinner="fetchingItem"
		/>
	</div>
</template>

<script>
	import moment from "moment";
	import ListNamesPopUp from "./ListNamesPopUp.vue";
	import AdAccountView from "./AdAccountView.vue"
	import SellerView from "./SellerView.vue"
	import VendorView from "./VendorView.vue"
	import InstacartView from "./InstacartView"
	import DSPView from "./DSPView"
	import AMCView from "./AMCView.vue";
	const formatCurrency = require("format-currency");

	export default {
		name: "Detail",
		data() {
			return {
				profileData: {},
				dataList: [],
				loader: false,
				clientData: {
					client: {},
					client_name: "",
					client_main_contact: "",
					go_ops: "",
					go_marketing: "",
					go_retail: "",
					partner_uuid:"",
					sharepoint_link:""
				},
				vendorData: [],
				sellerData: [],
				profileData: [],
				vendorList: [],
				amcList: [],
				type: "",
				details: [],
				name: "",
				fetchingItem: false
			};
		},
		props: ["clientId", "profileId"],
		components: {
			moment,
			ListNamesPopUp,
			AdAccountView,
			SellerView,
			VendorView,
			InstacartView,
			DSPView,
			AMCView
		},
		mounted() {
			this.$store.dispatch("callAnalytics", {data:window.location.href, this:this, type:'AccountDetails'})

			let vm = this;
			if (this.clientId) {
				this.getClientData();
			} else if (this.profileId) {
				this.getProfileData();
			}

			this.$store.dispatch("getAccountVendors").then(res => {
				vm.vendorList = res.filter(e => e.vendor_name);
			});
		},
		methods: {
			openLinkInNewTab(url){
				window.open(url)
			},
			viewListPopUp(type, profile) {
				const vm = this;
				this.type = type.charAt(0).toUpperCase() + type.slice(1);
				this.name = profile.customName;
				this.fetchingItem = true;
				this.$refs["listPopUp"].openPopUp();
				this.details = []
				this.$store
					.dispatch("accounts/getSellerVendorDetailForProfile", {
						type: type,
						profileId: profile.profile_id
					})
					.then(resp => {
						vm.details.push(resp);
						vm.fetchingItem = false;
					});
			},
			parseData(data) {
				let type = [];
				if (data.marketing_campaign_sp == true) {
					type.push("SP");
				}
				if (data.marketing_campaign_sb == true) {
					type.push("SB");
				}
				if (data.marketing_campaign_sd == true) {
					type.push("SD");
				}

				return type.join(", ");
			},
			rowDataFilter(arr) {
				let key = arr[0];
				let val = arr[1];

				let obj = {};
				obj[key] = val;
				this.dataList.push(obj);
			},
			parse(data) {
				let key = data.split("_");
				return key.join(" ");
			},
			parsedContacts(data) {
				let str = "";
				if (data) {
					if (data.first_name) {
						str = data.first_name;
					}
					if (data.last_name) {
						str = str + " " + data.last_name;
					}
				}
				return str;
			},
			getFormattedDate(date) {
				
				return  moment(date).format("MM/DD/YYYY");
			},
			getClientData() {
				let vm = this
				this.loader = true
				this.$store.dispatch("accounts/getAccountSections",{go_client_id:this.clientId}).then(res=>{
					vm.loader = false
					vm.clientData = res.clientData;
					let profiles = (res && res.profileData && res.profileData.length) ? res.profileData : [];
					vm.profileData = profiles.map(item => {
						if(item && item.type=='Ad Accounts'){
							item['monthly_budget'] = this.formatDailyBudget(item['monthly_budget']||0)
							let name = item.name
								? item.name + " ("
								: "";
							name =
								name +
								item.brand_entity_id +
								(item.name ? ")" : "");
							item["customName"] = name;
						}
						return item;
					});
					vm.showProfileInfo = true;
				})
			},
			getProfileData() {
				this.loader = true;
				let vm = this;
				this.$store
					.dispatch("accounts/getVendorDataById", {
						profile_id: this.profileId
					})
					.then(res => {
						vm.loader = false;
						vm.profileData.push(res);
					});
			},
			showProfileVendor(data) {
				let vendor = this.vendorList.find(e => e.vendor_id == data);
				return vendor ? vendor.vendor_name : "";
			},
			formatDailyBudget(num) {
				var num = formatCurrency(num);
				return num;
			},
		}
	};
</script>

<style lang="scss">
.label-wrapper-style {
	color: #888888;
}
.label-value-wrapper-style {
	margin: 0px;
}
.label-not-provided-wrapper {
	color: #e1dfdf;
}
.capital {
	text-transform: capitalize !important
}
</style>
